export enum GameVendorId {
    V_888 = 1,
    V_CTXM = 2,
    V_vsGaming = 3,
    V_Electracade = 4,
    V_LNW = 5,
    V_Rival = 6,
    V_Dynamite = 7,
    V_Ashgaming = 8,
    V_Crypto = 9,
    V_BlueSq = 10,
    V_Bellfruit = 11,
    V_Sportech = 12,
    V_Netent = 13,
    V_Evolution = 14,
    V_WagerWorks = 15,
    V_Betlow = 16,
    V_Fremantle = 17,
    V_Gamesq = 18,
    V_DSL = 19,
    V_Ponsbic = 20,
    V_Blueprint = 21,
    V_Endemol = 22,
    V_Mazooma = 23,
    V_Genesis = 24,
    V_RevolverGaming = 25,
    V_Kambi = 26,
    V_NetEnt = 27,
    V_LNW2 = 28,
    V_Ingenuity = 29,
    V_PlayTech = 30,
    V_UniversalStudios = 31,
    V_IGT = 32,
    V_Elk = 33,
    V_Thunderkick = 34,
    V_Merkur = 35,
    V_NextGenBigTime = 36,
    V_Sigma = 37,
    V_Wizard = 38,
    V_Quickspin = 39,
    V_GamesGlobal = 40,
    V_Yggdrasil = 41,
    V_Amatic = 42,
    V_BallyWulff = 43,
    V_Skilzz = 44,
    V_LightningBox = 46,
    V_RedTiger = 47,
    V_Pragmatic = 48,
    V_NorthernLight = 49,
    V_H5 = 50,
    V_RubyPlay = 51,
    V_NextGenChanceInteractive = 52,
    V_PlayNGo = 53,
    V_AGS = 54,
    V_Gamevy = 55,
    V_Eyecon = 56,
    V_Greentube = 57,
    V_iSoftBet = 58,
    V_Playson = 59,
    V_Spectate = 60,
    V_Inspired = 61,
    V_PGSoft = 62,
    V_Skywind = 63,
    V_Habanero = 64,
    V_MGA = 65,
    V_RFranco = 66,
    V_4theplayer = 67,
    V_Realistic = 68,
    V_Oryx = 69,
    V_ReelPlay = 70,
    V_GamingRealms = 71,
    V_Hacksaw = 72,
    V_PushGaming = 73,
    V_WMG = 74,
    V_1x2 = 75,
    V_GoldenRace = 76,
    V_Leap = 77,
    V_Core = 78,
    V_ReelNRG = 79,
    V_IronDog = 80,
    V_Authentic = 81,
    V_Gamomat = 82,
    V_EGT = 83,
    V_Endorphina = 84,
    V_Betsoft = 85,
    V_Playzido = 86,
    V_RedRake = 87,
    V_PlayzidoOthers = 88,
    V_TomHorn = 89,
    V_NeoGames = 90,
    V_BFGames = 91,
    V_Kalamba = 92,
    V_GiveMe = 93,
    V_GoldenHero = 94,
    V_2by2 = 95,
    V_PlankGaming = 96,
    V_BulletproofGames = 97,
    V_Ainsworth = 98,
    V_Everi = 99,
    V_Wazdan = 100,
    V_PlayzidoReelplay = 101,
    V_Gong = 102,
    V_NoLimitCity = 103,
    V_DWG = 104,
    V_TripleCherry = 105,
    V_Spearhead = 106,
    V_Spinomenal = 107,
    V_Spribe = 108,
    V_CIRSA = 109,
    V_Funfair = 110,
    V_GreenJade = 111,
    V_NazionaleElectronica = 112,
    V_Booming = 113,
    V_Darwin = 114,
    V_Betixon = 115,
    V_NetGaming = 116,
    V_BGaming = 117,
    V_BlueHorn = 118,
    V_SpinPlay = 119,
    V_Arcadia = 120,
    V_Stakelogic = 121,
    V_Live5 = 122,
    V_Swintt = 123,
    V_Edict = 124,
    V_GameArt = 125,
    V_LadyLuck = 126,
    V_SmartSoft = 127,
    V_Spinberry = 128,
    V_TopSpin = 129,
    V_eZugi = 130,
    V_IndigoMagic = 131,
    V_AtomicLabs = 132,
    V_Bluberi = 133,
    V_RAW = 134,
    V_Reevo = 135,
    V_WhiteHat = 136,
    V_Galaxis = 137,
    V_Synot = 138,
    V_EGTDigital = 139
  }